import * as constants from './constants';
import {get} from "../../../utils/request";
import {VENUE_INFO} from '../../../utils/api';

export const VenueDetail = (Entity) => ({
    type: constants.VENUE_DETAIL,
    value: Entity
});

export const getVenueDetail = (params) => {
    return (dispatch) => {
        return get(VENUE_INFO + "/" + params, params)
            .then((response) => {
                return dispatch(VenueDetail(response.data));
            });
    }
};
